import React from "react";
import {useSelector} from "react-redux";
import MaterialUIGroupedMultiSelect from "../selects/MaterialUIGroupedMultiSelect";


export default function AdminPartnersFilter({selectedPartners, handleChangeFilterData, isGroupSelectionDisabled, label='Партнёры',  inputStyle}) {
    const {partnerGroups} = useSelector(state => state.filterDataReducer.filterData);

    const onSelect = (value) => {
        handleChangeFilterData(value, true);
    };

    return (
        <MaterialUIGroupedMultiSelect
            styles={inputStyle}
            dropdownData={partnerGroups}
            groupDisplayedField='partnerType'
            groupDataField='partnerTypeId'
            values={selectedPartners}
            dataField='key'
            displayedField='partnerName'
            label={label}
            placeholder={'-'}
            onSelect={onSelect}
            isSearchable
            isGroupSelectionDisabled={isGroupSelectionDisabled}
        />
    );
}